import { render, staticRenderFns } from "./pick-landlord.vue?vue&type=template&id=b8ff40c6&"
import script from "./pick-landlord.vue?vue&type=script&lang=js&"
export * from "./pick-landlord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports